import sendForm from "./send-form";

document.addEventListener('DOMContentLoaded',function () {

    const requiredFields = {
        email: {
            presence: {message: "Pole nie może być puste"},
            email: {message: 'Adres nieprawidłowy'},
        },
        phone: {
            presence: {message: "Pole nie może być puste"},
            telCheck: "Podaj prawidłowy poprawny numer"
        },
        name: {
            presence: {message: "Pole nie może być puste"},
            length: {
                maximum: 100,
                minimum: 3,
                message: 'Min. 3 znaki'
            },
            format: {
                pattern: "[A-Za-ząćęłńóśźżĄĆĘŁŃÓŚŹŻ0-9 ,.'-]+",
                flags: "i",
                message: "Tylko znaki a-z i 0-9"
            }
        },
        body: {
            presence: {message: "Pole nie może być puste"},
            length: {
                maximum: 5000,
                minimum: 5,
                message: 'Min. 5 znaki'
            },
            format: {
                pattern: /[A-Za-ząćęłńóśźżĄĆĘŁŃÓŚŹŻ0-9\n ,.'-]+/,
                flags: "i",
                message: "Tylko znaki a-z i 0-9"
            }
        },
        agreement01: {
            presence: {message: "Pole wymagane"},
            inclusion: {
                within: [true],
                message: "^Zaznacz pole"
            }
        },
        // agreement02: {
        //     presence: {message: "Pole wymagane"},
        //     inclusion: {
        //         within: [true],
        //         message: "^Zaznacz pole"
        //     }
        // },
    }


    const requiredContactFormFields = {
        email: {
            presence: {message: "Pole nie może być puste"},
            email: {message: 'Adres nieprawidłowy'},
        },
        phone: {
            presence: {message: "Pole nie może być puste"},
            telCheck: "Podaj prawidłowy poprawny numer"
        },
        showroom: {
            presence: {message: "Wybierz salon"},
        },
        name: {
            presence: {message: "Pole nie może być puste"},
            length: {
                maximum: 100,
                minimum: 3,
                message: 'Min. 3 znaki'
            },
            format: {
                pattern: "[A-Za-ząćęłńóśźżĄĆĘŁŃÓŚŹŻ0-9 ,.'-]+",
                flags: "i",
                message: "Tylko znaki a-z i 0-9"
            }
        },
        body: {
            presence: {message: "Pole nie może być puste"},
            length: {
                maximum: 5000,
                minimum: 5,
                message: 'Min. 5 znaki'
            },
            format: {
                pattern: /[A-Za-ząćęłńóśźżĄĆĘŁŃÓŚŹŻ0-9\n ,.'-]+/,
                flags: "i",
                message: "Tylko znaki a-z i 0-9"
            }
        },
        agreement01: {
            presence: {message: "Pole wymagane"},
            inclusion: {
                within: [true],
                message: "^Zaznacz pole"
            }
        },
        // agreement02: {
        //     presence: {message: "Pole wymagane"},
        //     inclusion: {
        //         within: [true],
        //         message: "^Zaznacz pole"
        //     }
        // },
    }

    const requiredFieldsOfferPage = {
        email: {
            presence: {message: "Pole nie może być puste"},
            email: {message: 'Adres nieprawidłowy'},
        },
        phone: {
            presence: {message: "Pole nie może być puste"},
            telCheck: "Podaj prawidłowy poprawny numer"
        },
        name: {
            presence: {message: "Pole nie może być puste"},
            length: {
                maximum: 100,
                minimum: 3,
                message: 'Min. 3 znaki'
            },
            format: {
                pattern: "[A-Za-ząćęłńóśźżĄĆĘŁŃÓŚŹŻ0-9 ,.'-]+",
                flags: "i",
                message: "Tylko znaki a-z i 0-9"
            }
        },
        body: {
            presence: {message: "Pole nie może być puste"},
            length: {
                maximum: 5000,
                minimum: 5,
                message: 'Min. 5 znaki'
            },
            format: {
                pattern: /[A-Za-ząćęłńóśźżĄĆĘŁŃÓŚŹŻ0-9\n ,.'-]+/,
                flags: "i",
                message: "Tylko znaki a-z i 0-9"
            }
        },
        agreement01: {
            presence: {message: "Pole wymagane"},
            inclusion: {
                within: [true],
                message: "^Zaznacz pole"
            }
        },
        // agreement02: {
        //     presence: {message: "Pole wymagane"},
        //     inclusion: {
        //         within: [true],
        //         message: "^Zaznacz pole"
        //     }
        // },
    }
    // popupMessage("Dziękujemy za wysłanie wiadomości. Odpowiemy najszybciej jak to możliwe.");
    const form = document.getElementById('contact-form');
    const contactForm = document.getElementById('contact-form-showrooms');

    if (form) {
        sendForm(form, requiredFields)
    }
    if (contactForm) {
        sendForm(contactForm, requiredContactFormFields)
    }

    window.offerForm = function () {

        sendForm(document.querySelector('.gslider form'), requiredFieldsOfferPage)
            .then(function (response) {
                window.lightbox.close();
            }).catch(function (error) {
            console.error(error);
        });
    }

});
